export enum PasswordFormNames {
	password = 'Password',
	create_password = 'Create Password',
	otpCode = 'otpCode',
}
